import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '.././globals';
import { HttpClient,HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class CommunityListService {

  constructor(private http: HttpClient, private globals: Globals, private router: Router) { }

  getTopCommunity(flag,id,search) {
    //debugger
    var entity = {
      'categoryId' : id,
      'flag' : flag,
      'search': search
    }
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.globals.baseAPIUrl + 'communityList',entity)
        .toPromise()
        .then(
          res => { // Success
            resolve(res);
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }
}
